<template>
  <div style="width: 100%;height: 100%;" class="overflow-auto px-16px pt-16px pb-16px">
    <div class="search flex items-center gap-4px mb-10px]">
      <el-input v-model="searchValue" placeholder="请输入搜索内容" clearable :prefix-icon="Search" style="margin-right: 16px;"
        @clear="elementShow = false"></el-input>
      <el-button type="primary" @click="handleSearch" style="background-color: #2a66ff;">搜索</el-button>
    </div>
    <div class="imageList-wrap mb-[24px]" v-if="!elementShow">
      <button class="lefticon" @click="scrollLeft" v-if="canScrollLeft">
        <el-icon>
          <ArrowLeft />
        </el-icon>
      </button>
      <div class="imageList" ref="listRef" @scroll="onScroll" v-if="menuList.length > 0">
        <div v-for="item in menuList" :key="item.id" class="menu-items" @click="handleCategorySelect(item)">
          {{ item.name }}
        </div>
      </div>
      <button class="righticon" @click="scrollRight" v-if="canScrollRight">
        <el-icon>
          <ArrowRight />
        </el-icon>
      </button>
    </div>
    <div v-if="!elementShow">
      <recommendSection @more="handleCategorySelect($event)" />
    </div>
    <div class="elementList-wrap" v-if="elementShow">
      <elementlist :category="categoryopt" @back="elementShow = false" ref="elementlistRef" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, reactive, computed, onMounted, nextTick } from 'vue';
import { ElInput, ElButton, ElCascader, ElIcon } from 'element-plus'
import { ArrowDown, Search, ArrowLeft, ArrowRight } from '@element-plus/icons-vue'
import { getMaterialsPages } from '@/api/affairs'
const menuList = ref([])
const searchValue = ref('')
//@ts-ignore
import recommendSection from './recommendSection.vue'
//@ts-ignore
import elementlist from './elementlist.vue'
const listRef = ref<HTMLElement | null>(null)
const canScrollLeft = ref(false)
const canScrollRight = ref(false)
const elementShow = ref(false)
const elementlistRef = ref<typeof elementlist>()
onMounted(() => {
  getMaterialsPages({ page: 1, size: 50, type: '2' }).then(res => {
    menuList.value = res.data.data.items
    updateScrollState()
  })
})

const updateScrollState = () => {
  const el = listRef.value
  if (!el) return
  canScrollLeft.value = el.scrollLeft > 0
  canScrollRight.value = el.scrollLeft + el.clientWidth < el.scrollWidth
}

const onScroll = () => updateScrollState()
const scrollLeft = () => listRef.value?.scrollBy({ left: -200, behavior: 'smooth' })
const scrollRight = () => listRef.value?.scrollBy({ left: 200, behavior: 'smooth' })
const categoryopt = ref('')
const handleCategorySelect = (e: any) => {
  categoryopt.value = e
  console.log(e)
  elementShow.value = true
}

const handleSearch = () => {
  categoryopt.value = ''
  elementShow.value = false
  nextTick(() => {
    if (!searchValue.value) {
      return
    }
    elementShow.value = true
    nextTick(() => {
      elementlistRef.value?.pagesearch(searchValue.value)
    })
  })

}
</script>
<style lang="scss">
.imageList {
  width: 100%;
  overflow: auto;
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
  margin-top: 16px;

  &::-webkit-scrollbar {
    display: none;
  }

  .menu-items {
    display: inline-block;
    padding: 0px 8px;
    background-color: #f1f1f1;
    line-height: 30px;
    border-radius: 6px;
    margin-right: 8px;
    cursor: pointer;
  }
}

.imageList-wrap {
  position: relative;
}


.lefticon {
  position: absolute;
  z-index: 100;
  top: 2px;
  left: -12px;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  background-color: #fff;
  cursor: pointer;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
  display: none;
}

.righticon {
  top: 2px;
  position: absolute;
  background-color: #fff;
  right: -12px;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
}

.show {
  opacity: 1;
  display: block;
}

.skeleton-pill {
  width: 64px;
  height: 24px;
  border-radius: 12px;
}
</style>
